import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalTermsOfUseIT extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Condizioni generali di utilizzo e informazioni legali';
		const siteDescription = 'Condizioni generali di utilizzo e informazioni legali descrizione';
		const siteKeywords = 'Condizioni generali di utilizzo e informazioni legali parole chiave';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/termsofuse/it';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Termini e condizioni</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<InfoPageTitle1>Termini generali </InfoPageTitle1>
						<p>
							Accedendo e effettuando un ordine su Glossiq, confermi di essere in accordo con e vincolato dai termini di
							servizio contenuti nei Termini e Condizioni di seguito descritti. Questi termini si applicano all'intero
							sito web e a qualsiasi email o altro tipo di comunicazione tra te e Glossiq.
						</p>
						<p>
							In nessun caso il team di Glossiq sarà responsabile per danni diretti, indiretti, speciali, incidentali o
							consequenziali, inclusa, ma non limitata a, la perdita di dati o di profitti, derivanti dall'uso o
							dall'incapacità di utilizzare i materiali presenti su questo sito, anche se il team di Glossiq o un
							rappresentante autorizzato avesse avvertito della possibilità di tali danni. Se l'uso dei materiali di
							questo sito comporta la necessità di assistenza, riparazione o correzione dell'attrezzatura o dei dati, si
							assume tutti i costi correlati.
						</p>
						<p>
							Glossiq non sarà responsabile per alcun risultato che potrebbe verificarsi durante l'uso delle nostre
							risorse. Ci riserviamo il diritto di modificare i prezzi e rivedere la politica di utilizzo delle risorse
							in qualsiasi momento.
						</p>

						<InfoPageTitle1>Licenza </InfoPageTitle1>

						<p>
							Glossiq ti concede una licenza revocabile, non esclusiva, non trasferibile e limitata per scaricare,
							installare e utilizzare il sito web strettamente in conformità con i termini di questo Accordo.
						</p>

						<p>
							Questi Termini e Condizioni sono un contratto tra te e Glossiq (riferiti in questi Termini e Condizioni
							come "Glossiq", "noi", "ci" o "nostro"), il fornitore del sito web di Glossiq e dei servizi accessibili
							dal sito web di Glossiq (che sono collettivamente indicati in questi Termini e Condizioni come il
							"Servizio di Glossiq").
						</p>

						<p>
							Stai accettando di essere vincolato da questi Termini e Condizioni. Se non accetti questi Termini e
							Condizioni, ti preghiamo di non utilizzare il Servizio di Glossiq. In questi Termini e Condizioni, "tu" si
							riferisce sia a te come individuo che all'entità che rappresenti. Se violi uno qualsiasi di questi Termini
							e Condizioni, ci riserviamo il diritto di cancellare il tuo account o bloccare l'accesso al tuo account
							senza preavviso.
						</p>

						<InfoPageTitle1>Definizioni e termini chiave</InfoPageTitle1>
						<p>
							Per spiegare le cose nel modo più chiaro possibile in questi Termini e Condizioni, ogni volta che uno
							qualsiasi di questi termini viene menzionato, viene strettamente definito come segue:
						</p>
						<ul>
							<li>
								Cookie: piccola quantità di dati generati da un sito web e salvati dal tuo browser web. Viene utilizzato
								per identificare il tuo browser, fornire analisi, ricordare informazioni su di te come la tua preferenza
								di lingua o le informazioni di accesso.
							</li>
							<li>
								Azienda: quando questi termini menzionano "Azienda," "noi," "ci," o "nostro," si riferisce a Glossiq,
								che è responsabile delle tue informazioni in base a questi Termini e Condizioni.
							</li>
							<li>
								Paese: dove Glossiq o i proprietari/fondatori di Glossiq sono basati, in questo caso è la Slovenia.
							</li>
							<li>
								Dispositivo: qualsiasi dispositivo connesso a Internet come un telefono, tablet, computer o qualsiasi
								altro dispositivo che può essere utilizzato per visitare Glossiq e utilizzare i servizi.
							</li>
							<li>
								Servizio: si riferisce al servizio fornito da Glossiq come descritto nei termini relativi (se
								disponibili) e su questa piattaforma.
							</li>
							<li>
								Servizio di terze parti: si riferisce a inserzionisti, sponsor di concorsi, partner promozionali e di
								marketing e altri che forniscono il nostro contenuto o i cui prodotti o servizi riteniamo possano
								interessarti.
							</li>
							<li>Sito web: il sito di Glossiq, accessibile tramite questo URL: www.glossiq.com</li>
							<li>Tu: una persona o un'entità registrata presso Glossiq per utilizzare i Servizi.</li>
						</ul>

						<InfoPageTitle1>Restrizioni </InfoPageTitle1>

						<p>Accetti di non, e non permetterai ad altri di:</p>

						<ul>
							<li>
								Concedere in licenza, vendere, affittare, assegnare, distribuire, trasmettere, ospitare, esternalizzare,
								divulgare o altrimenti commercializzare il sito web o rendere la piattaforma disponibile a terze parti.
							</li>

							<li>
								Modificare, creare opere derivate, smontare, decrittografare, decompilare inversamente o ingegnerizzare
								inversamente una parte del sito web.
							</li>

							<li>
								Rimuovere, alterare o oscurare qualsiasi avviso di proprietà (incluso qualsiasi avviso di copyright o
								marchio) di Glossiq o delle sue affiliate, partner, fornitori o licenzianti del sito web.
							</li>
						</ul>

						<InfoPageTitle1>Pagamento </InfoPageTitle1>

						<p>
							Se ti registri a uno dei nostri piani di pagamento ricorrenti, accetti di pagare tutte le spese o i costi
							sul tuo account per il Servizio in conformità con le tariffe, le spese e i termini di fatturazione in
							vigore al momento in cui ogni spesa o addebito è dovuto e pagabile. A meno che non venga indicato
							diversamente in un modulo d'ordine, devi fornire a Glossiq una carta di credito valida (Visa, MasterCard o
							qualsiasi altro emittente accettato da noi) ("Provider di pagamento") come condizione per l'iscrizione al
							piano Premium. L'accordo del Provider di pagamento regola l'uso del tuo account di carta di credito
							designato e devi fare riferimento a tale accordo e non a questi Termini per determinare i tuoi diritti e
							le tue responsabilità nei confronti del tuo Provider di pagamento. Fornendo a Glossiq il numero della tua
							carta di credito e le informazioni di pagamento associate, accetti che Glossiq sia autorizzato a
							verificare immediatamente le informazioni e successivamente ad emettere una fattura al tuo account per
							tutte le spese e gli addebiti dovuti e pagabili a Glossiq in virtù di questi Termini e Condizioni e che
							nessun ulteriore avviso o consenso è richiesto. Accetti di notificare immediatamente a Glossiq qualsiasi
							modifica del tuo indirizzo di fatturazione o della carta di credito utilizzata per il pagamento in virtù
							di questo Accordo. Glossiq si riserva il diritto di cambiare in qualsiasi momento i suoi prezzi e i metodi
							di fatturazione, sia immediatamente dopo la pubblicazione sul nostro sito o tramite la consegna via e-mail
							agli amministratori della tua organizzazione. Eventuali spese legali, costi processuali o altri costi
							sostenuti per il recupero di importi non pagati non contestati saranno a carico e pagati da te. Nessun
							contratto esisterà tra te e Glossiq per il Servizio fino a quando Glossiq accetterà il tuo ordine tramite
							una e-mail di conferma, messaggio SMS/MMS o altro mezzo di comunicazione appropriato. Sei responsabile per
							eventuali spese di terze parti che potresti sostenere durante l'uso del Servizio.
						</p>

						<InfoPageTitle1>Politica di ritorno e rimborso</InfoPageTitle1>

						<p>
							Grazie per aver fatto acquisti su Glossiq. Apprezziamo il fatto che ti piaccia acquistare le cose che
							costruiamo. Vogliamo anche assicurarci che tu abbia un'esperienza gratificante mentre esplori, valuti e
							acquisti i nostri prodotti.
						</p>

						<p>
							Come in qualsiasi esperienza di acquisto, ci sono termini e condizioni che si applicano alle transazioni
							su Glossiq. Sarà un riassunto quanto i nostri avvocati ci permetteranno. La cosa principale da ricordare è
							che effettuando un ordine o un acquisto su Glossiq, accetti i termini insieme alla Politica sulla privacy
							di Glossiq.
						</p>

						<p>
							Se, per qualsiasi motivo, non sei completamente soddisfatto di un qualsiasi bene o servizio che forniamo,
							non esitare a contattarci e discuteremo qualsiasi problema tu stia riscontrando con il nostro prodotto.
						</p>

						<InfoPageTitle1>Le tue suggerimenti </InfoPageTitle1>

						<p>
							Eventuali feedback, commenti, idee, miglioramenti o suggerimenti (collettivamente, "Suggerimenti") forniti
							da te a Glossiq relativamente al sito web rimarranno di proprietà esclusiva di Glossiq.
						</p>

						<p>
							Glossiq sarà libero di utilizzare, copiare, modificare, pubblicare o ridistribuire i Suggerimenti per
							qualsiasi scopo e in qualsiasi modo, senza alcun credito o compensazione a te.
						</p>

						<InfoPageTitle1>Il tuo consenso </InfoPageTitle1>

						<p>
							Abbiamo aggiornato i nostri Termini e Condizioni per fornirti completa trasparenza su ciò che viene
							impostato quando visiti il nostro sito e come viene utilizzato. Utilizzando il nostro sito web,
							registrando un account o effettuando un acquisto, acconsenti ai nostri Termini e Condizioni.
						</p>

						<InfoPageTitle1>Collegamenti ad altri siti web </InfoPageTitle1>

						<p>
							Questi Termini e Condizioni si applicano solo ai Servizi. I Servizi possono contenere collegamenti ad
							altri siti web non operati o controllati da Glossiq. Non siamo responsabili per i contenuti, l'accuratezza
							o le opinioni espresse in tali siti web, e tali siti web non sono indagati, monitorati o verificati per
							accuratezza o completezza da noi. Ti ricordiamo che quando utilizzi un collegamento per passare dai
							Servizi a un altro sito web, i nostri Termini e Condizioni non sono più in vigore. La tua navigazione e
							interazione su qualsiasi altro sito web, inclusi quelli che hanno un collegamento sulla nostra
							piattaforma, è soggetta alle regole e alle politiche di quel sito web. Tali terze parti possono utilizzare
							i loro cookie o altri metodi per raccogliere informazioni su di te.
						</p>

						<InfoPageTitle1>Cookie </InfoPageTitle1>

						<p>
							Glossiq utilizza i "Cookie" per identificare le aree del nostro sito web che hai visitato. Un Cookie è un
							piccolo pezzo di dati memorizzato sul tuo computer o dispositivo mobile dal tuo browser web. Utilizziamo i
							Cookie per migliorare le prestazioni e la funzionalità del nostro sito web, ma non sono essenziali per il
							loro utilizzo. Tuttavia, senza questi cookie, alcune funzionalità come i video potrebbero diventare
							indisponibili o ti sarebbe richiesto di inserire i dettagli di accesso ogni volta che visiti il sito web
							poiché non potremmo ricordare che avevi effettuato l'accesso in precedenza. La maggior parte dei browser
							web può essere configurata per disabilitare l'uso dei Cookie. Tuttavia, se disabiliti i Cookie, potresti
							non essere in grado di accedere correttamente o del tutto alle funzionalità del nostro sito web. Non
							inseriamo informazioni personalmente identificabili nei Cookie.
						</p>

						<InfoPageTitle1>Modifiche ai nostri Termini e Condizioni</InfoPageTitle1>

						<p>
							Riconosci e accetti che Glossiq può interrompere (in modo permanente o temporaneo) la fornitura del
							Servizio (o di qualsiasi funzionalità all'interno del Servizio) a te o agli utenti in generale a sua sola
							discrezione, senza preavviso preventivo a te. Puoi smettere di utilizzare il Servizio in qualsiasi
							momento. Non è necessario informare esplicitamente Glossiq quando smetti di utilizzare il Servizio.
							Riconosci e accetti che se Glossiq disabilita l'accesso al tuo account, potresti essere impedito di
							accedere al Servizio, ai dettagli del tuo account o a qualsiasi file o altro materiale contenuto nel tuo
							account.
						</p>

						<p>
							Se decidiamo di modificare i nostri Termini e Condizioni, pubblicheremo tali modifiche su questa pagina
							e/o aggiorneremo la data di modifica dei Termini e Condizioni qui sotto.
						</p>

						<InfoPageTitle1>Modifiche al nostro sito web</InfoPageTitle1>

						<p>
							Glossiq si riserva il diritto di modificare, sospendere o interrompere, in modo permanente o temporaneo,
							il sito web o qualsiasi servizio a cui è collegato, con o senza preavviso e senza responsabilità nei tuoi
							confronti.
						</p>

						<InfoPageTitle1>Aggiornamenti al nostro sito web </InfoPageTitle1>

						<p>
							Glossiq potrebbe occasionalmente fornire miglioramenti o miglioramenti alle funzionalità/la funzionalità
							del sito web, che possono includere patch, correzioni di bug, aggiornamenti, miglioramenti e altre
							modifiche ("Aggiornamenti").
						</p>

						<p>
							Gli Aggiornamenti possono modificare o eliminare determinate funzionalità e/o funzionalità del sito web.
							Accetti che gli Aggiornamenti saranno considerati (i) parte integrante del sito web e (ii) soggetti ai
							termini e alle condizioni di questo Accordo.
						</p>

						<InfoPageTitle1>Servizi di terze parti </InfoPageTitle1>

						<p>
							Potremmo visualizzare, includere o mettere a disposizione contenuti di terze parti (inclusi dati,
							informazioni, applicazioni e altri prodotti o servizi) o fornire collegamenti a siti web o servizi di
							terze parti ("Servizi di terze parti").
						</p>

						<p>
							Riconosci e accetti che Glossiq non sarà responsabile per nessun Servizio di terze parti, inclusa la loro
							accuratezza, completezza, tempestività, validità, conformità al copyright, legalità, decenza, qualità o
							qualsiasi altro aspetto. Glossiq non assume e non avrà alcuna responsabilità nei tuoi confronti o nei
							confronti di qualsiasi altra persona o entità per qualsiasi Servizio di terze parti.
						</p>

						<p>
							I Servizi di terze parti e i collegamenti ad essi sono forniti esclusivamente per tua comodità e accedi e
							li utilizzi interamente a tuo rischio e soggetto ai termini e alle condizioni di tali terze parti.
						</p>

						<InfoPageTitle1>Termine e risoluzione </InfoPageTitle1>

						<p>Questo Accordo rimarrà in vigore fino alla sua risoluzione da parte tua o di Glossiq.</p>

						<p>
							Glossiq può, a sua sola discrezione, in qualsiasi momento e per qualsiasi motivo o senza motivo,
							sospendere o risolvere questo Accordo con o senza preavviso preventivo.
						</p>

						<p>
							Questo Accordo terminerà immediatamente, senza preavviso preventivo da parte di Glossiq, nel caso in cui
							tu non ottemperassi a una qualsiasi disposizione di questo Accordo. Puoi anche terminare questo Accordo
							eliminando il sito web e tutte le sue copie dal tuo computer.
						</p>

						<p>
							Alla cessazione di questo Accordo, dovrai cessare tutto l'uso del sito web e cancellare tutte le copie del
							sito web dal tuo computer.
						</p>

						<p>
							La risoluzione di questo Accordo non limiterà nessuno dei diritti o dei rimedi di Glossiq in conformità
							alla legge o all'equità in caso di violazione da parte tua (durante il periodo di validità di questo
							Accordo) di qualsiasi obbligo previsto dal presente Accordo.
						</p>

						<InfoPageTitle1>Avviso di violazione del copyright</InfoPageTitle1>

						<p>
							Se sei il titolare del copyright o l'agente di tale titolare e ritieni che qualsiasi materiale presente
							sul nostro sito web costituisca una violazione del tuo copyright, contattaci fornendo le seguenti
							informazioni: (a) firma fisica o elettronica del titolare del copyright o di una persona autorizzata ad
							agire per suo conto; (b) identificazione del materiale che si ritiene costituisca una violazione; (c) le
							tue informazioni di contatto, compreso l'indirizzo, il numero di telefono e un indirizzo e-mail; (d) una
							dichiarazione da parte tua che hai motivo di ritenere che l'uso del materiale non sia autorizzato dai
							titolari dei diritti d'autore; e (e) una dichiarazione che le informazioni nella notifica sono accurate e
							che, a pena di spergiuro, sei autorizzato ad agire per conto del titolare.
						</p>

						<InfoPageTitle1>Indennizzo </InfoPageTitle1>

						<p>
							Accetti di indennizzare e tenere indenne Glossiq e le sue società madri, sussidiarie, affiliate,
							dirigenti, dipendenti, agenti, partner e licenzianti (se presenti) da qualsiasi reclamo o richiesta,
							comprese le spese ragionevoli per gli avvocati, dovute o derivanti da: (a) l'uso del sito web; (b) la
							violazione di questo Accordo o di qualsiasi legge o regolamento; o (c) la violazione di qualsiasi diritto
							di terzi.
						</p>

						<InfoPageTitle1>Nessuna garanzia </InfoPageTitle1>

						<p>
							Il sito web ti viene fornito "COME È" e "COME DISPONIBILE" e con tutti i difetti e difetti senza garanzia
							di alcun tipo. Nella misura massima consentita dalla legge applicabile, Glossiq, per conto proprio e per
							conto delle sue affiliate e dei suoi rispettivi licenzianti e fornitori di servizi, nega espressamente
							tutte le garanzie, siano esse espresse, implicite, legali o di altro tipo, relative al sito web, comprese
							tutte le garanzie implicite di commerciabilità, idoneità a uno scopo particolare, titolo e non violazione,
							e garanzie che possano derivare da una prassi commerciale, da un comportamento abituale, da un utilizzo o
							da una prassi commerciale. Senza limitazione di quanto sopra, Glossiq non fornisce alcuna garanzia o
							impegno e non fa alcuna rappresentazione di alcun tipo che il sito web soddisferà i tuoi requisiti,
							otterrà risultati desiderati, sarà compatibile o funzionerà con qualsiasi altro software, sito web,
							sistema o servizio, funzionerà senza interruzioni, soddisferà norme di prestazione o affidabilità o sarà
							privo di errori o che eventuali errori o difetti possano o saranno corretti.
						</p>

						<p>
							Senza limitare quanto sopra, né Glossiq né alcun fornitore di servizi di Glossiq rende alcuna
							rappresentazione o garanzia di alcun tipo, esplicita o implicita: (a) quanto all'accuratezza, adeguatezza,
							tempestività o completezza del sito web o delle informazioni contenute o ottenute dal sito web; (b) che
							l'utilizzo del sito web sarà sicuro, senza interruzioni o privo di errori; (c) per quanto riguarda la
							qualità del sito web o di qualsiasi contenuto ottenuto attraverso il sito web; o (d) che i difetti nel
							sito web saranno corretti.
						</p>

						<p>
							Non assumiamo alcuna responsabilità e non possiamo garantire che il sito web sia privo di virus o di
							qualsiasi altro materiale dannoso. Eventuali contenuti scaricati o altrimenti ottenuti attraverso
							l'utilizzo del sito web sono scaricati a tuo rischio e pericolo e sei il solo responsabile di qualsiasi
							danno al tuo sistema informatico o perdita di dati risultante dal download di tali contenuti. La
							visualizzazione delle informazioni o il download di qualsiasi materiale attraverso l'utilizzo del sito web
							avviene a tua discrezione e a tuo rischio, e sarai il solo responsabile di qualsiasi danno al tuo sistema
							informatico o perdita di dati risultante dal download di tali materiali. Alcuni stati o giurisdizioni non
							consentono l'esclusione di garanzie implicite o la limitazione o l'esclusione di responsabilità per danni
							incidental o consequenziali, quindi le limitazioni o le esclusioni sopra riportate potrebbero non
							applicarsi a te. In tali stati o giurisdizioni, la responsabilità di Glossiq sarà limitata nella misura
							massima consentita dalla legge.
						</p>

						<InfoPageTitle1>Limitazione di responsabilità </InfoPageTitle1>

						<p>
							In nessun caso Glossiq o i suoi fornitori di servizi saranno responsabili nei tuoi confronti o nei
							confronti di qualsiasi altra persona o entità per danni diretti, indiretti, speciali, incidentali,
							consequenziali o punitivi di qualsiasi tipo, compresi, ma non limitati a, perdita di profitti, perdita di
							opportunità, perdita di dati, costi di copertura o qualsiasi altra perdita o danno di qualsiasi tipo,
							anche se informati della possibilità di tali danni, sia in un'azione contrattuale, illecita (compresa la
							negligenza), responsabilità oggettiva o in altra forma derivante o in connessione con l'utilizzo o
							l'incapacità di utilizzare il sito web o qualsiasi servizio o contenuto (inclusi i materiali) presenti sul
							sito web o ottenuti attraverso il sito web. In nessun caso la responsabilità complessiva di Glossiq per
							tutti i reclami derivanti da o in connessione con l'uso del sito web o dei servizi o contenuti presenti
							sul sito web eccederà l'importo pagato da te a Glossiq, se applicabile, per l'uso del sito web durante il
							periodo di tre (3) mesi immediatamente precedenti la data in cui è sorta la causa del reclamo. Alcuni
							stati o giurisdizioni non consentono l'esclusione o la limitazione di responsabilità per danni
							consequenziali o incidentali, quindi le limitazioni o le esclusioni sopra riportate potrebbero non
							applicarsi a te. In tali stati o giurisdizioni, la responsabilità di Glossiq sarà limitata nella misura
							massima consentita dalla legge.
						</p>

						<InfoPageTitle1>Riconoscimento </InfoPageTitle1>

						<p>
							Riconosci che hai letto questi Termini e Condizioni, comprese la Politica sulla privacy, e accetti tutti i
							loro termini e condizioni. Utilizzando il sito web o i servizi, accetti essere vincolato da questi Termini
							e Condizioni. Se non accetti i termini di questi Termini e Condizioni, non sei autorizzato a utilizzare il
							sito web o i servizi.
						</p>

						<InfoPageTitle1>Contattaci </InfoPageTitle1>
						<p>Se hai domande su questi Termini e Condizioni, contattaci all'indirizzo</p>
						<p>
							Email: <a href="mailto:support@glossiq.com">support@glossiq.com</a>
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalTermsOfUseIT };
